<template>
  <div class="date_picker">
    <div style="flex: 1">
      <el-popover
        v-model="startDatePopShow"
        placement="bottom"
        width="300"
        trigger="click"
      >
        <van-datetime-picker
          v-model="startDate"
          type="date"
          @confirm="handleStartDateConfirm"
        />
        <div class="picker_choose start_c" slot="reference">
          <Icon class="choose_date" icon="icon-riqi" />
          <div class="choose_text">
            <span class="text_value" v-if="date[0]">{{
              parseFormatDay(date[0])
            }}</span>
            <div class="text_placeholder text_ellipsis_1" v-else>开始日期</div>
          </div>
        </div>
      </el-popover>
    </div>
    <div class="date_picker_end" style="flex: 1">
      <el-popover
        v-model="endDatePopShow"
        placement="bottom"
        width="300"
        trigger="click"
      >
        <van-datetime-picker
          v-model="endDate"
          type="date"
          @confirm="handleEndDateConfirm"
          :min-date="startDate"
          :max-date="maxDate"
        />
        <div class="picker_choose end_c" slot="reference">
          <Icon class="choose_date" icon="icon-riqi" />
          <div class="choose_text">
            <span class="text_value" v-if="date[1]">{{
              parseFormatDay(date[1])
            }}</span>
            <div class="text_placeholder text_ellipsis_1" v-else>结束日期</div>
          </div>
        </div>
      </el-popover>

      <Icon
        v-if="date[1] && isClear"
        class="date_picker_end_clear"
        icon="icon-shanchu"
        @click="handlePickerClearClick"
      />
    </div>
  </div>
</template>

<script>
import timeMixin from "@/mixin/timeMixin";

export default {
  name: "lp-date-picker",
  mixins: [timeMixin],
  props: {
    maxDate: {
      type: Date,
      return: () => {},
    },
    isClear: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      startDate: new Date(),
      endDate: new Date(),
      date: [],
      startDatePopShow: false,
      endDatePopShow: false,
    };
  },
  methods: {
    handleStartDateConfirm() {
      this.startDatePopShow = false;
      const startTime = this.startDate.getTime();
      this.$set(this.date, 0, new Date(startTime));
      this.handleChooseDateFinish();

      this.$nextTick(() => {
        this.$set(
          this.date,
          1,
          this.maxDate || new Date(this.endDate.getTime())
        );
        this.handleChooseDateFinish();
      });
    },
    handleEndDateConfirm() {
      this.endDatePopShow = false;
      this.$set(this.date, 1, new Date(this.endDate.getTime()));
      this.handleChooseDateFinish();
    },
    handleChooseDateFinish() {
      if (this.date[0] && this.date[1]) {
        this.$emit("finish", [
          this.parseFormatDay(this.date[0]),
          this.parseFormatDay(this.date[1]),
        ]);
      }
    },
    resetDate() {
      this.startDate = new Date();
      this.endDate = new Date();
      this.date = [];
    },
    handlePickerClearClick() {
      this.resetDate();
      this.$emit("finish", []);
    },
    setDate(startDate, endDate) {
      this.$set(this.date, 0, new Date(startDate));
      this.$set(this.date, 1, new Date(endDate));
    },
  },
};
</script>

<style lang="scss" scoped>
.date_picker {
  position: relative;
  display: flex;
  margin-bottom: 20px;

  .start_c {
    border-radius: 4px 0 0 4px;
    border-right-color: transparent !important;
  }

  .date_picker_end {
    position: relative;

    .end_c {
      border-radius: 0 4px 4px 0;
    }

    .date_picker_end_clear {
      display: none;
      color: #aaa;
      position: absolute;
      z-index: 999;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
      cursor: pointer;
    }

    &:hover {
      .date_picker_end_clear {
        display: block;
      }
    }
  }

  .picker_choose {
    display: flex;
    // flex-wrap: no-wrap;
    background-color: #fff;
    background-image: none;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    // display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    // padding: 0 60px 0 20px;
    padding-left: 20px;
    width: 100%;
    &:hover {
      border-color: #c4c9d4 !important;
    }

    .choose_date {
      margin-right: 15px;
    }

    .choose_text {
      // display: flex;
      font-size: 14px;

      .text_value {
        color: #606266;
      }

      .text_placeholder {
        color: #cccfd6;
      }
    }
  }
}
</style>
